<template>
  <div class="register mt-4">
    <v-card
      class="mx-auto card-confirm-register"
      max-width="800"
      style="margin-top: 300px"
    >
      <v-card-subtitle class="pb-0 register-title"
        ><h3>
          {{
            $t('register-page.register-success.title', {
              split: '/'
            })
          }}
        </h3>
      </v-card-subtitle>

      <v-card-text class="text--primary mt-3">
        <div class="confirm-noti">
          {{
            $t('register-page.register-success.confirm-noti', {
              split: '/'
            })
          }}
        </div>
        <br />
        <div
          v-html="
            $t('register-page.register-success.confirm-mail', {
              split: '/',
              br: '<br>',
              url_valid_time: c_system ? c_system.url_valid_time : 24
            })
          "
        ></div>
      </v-card-text>

      <v-card-actions class="d-flex flex-row justify-center">
        <div class="my-5 text-center">
          <router-link
            tag="button"
            class="btn-next"
            :to="{ name: 'login-applicant' }"
            >{{
              $t('register-page.btn.btn-return-login', {
                split: '/'
              })
            }}</router-link
          >
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'StepOne',
  components: {},
  data: () => {
    return {};
  },

  methods: {},

  computed: {
    ...mapGetters({
      c_time_zone: 'getCTimeZone',
      registerResult: 'getRegisterResult'
    })
  },

  beforeCreate() {
    if (this.registerResult === null) {
      this.$router.replace({
        name: 'register-applicant',
        query: { event_day_register_url_code: this.urlRegisterCode, step: 1 }
      });
    }
  },

  mounted() {
    if (this.registerResult) {
      localStorage.removeItem('registerData');
    }
  },

  destroyed() {
    if (this.urlRegisterCode !== null && this.registerResult) {
      this.$store.dispatch('setRegistrationPeriodStatus', false);
    }
  }
};
</script>

<style>
.register-title {
  color: #333 !important;
}
.text-code {
  font-weight: 600;
  color: #333;
}
@media only screen and (max-width: 320px) {
  .btn-next {
    padding: 0px 10px !important;
  }
}
</style>
